import React, { useState, useEffect } from 'react'
import ActivityIndicator from "../../Helpers/ActivityIndicator";
import { useApi } from "../../../context/ApiProvider";
import PreviewPaginator from '../../Helpers/PreviewPaginator';
import RolfingTemplatePreviewPages from '../../Helpers/Modals/RolfingTemplatePreviewPages';
import Modal from '../../Helpers/Modals/Modal';
import CloneTemplateForm from '../../Helpers/CloneTemplateForm';
import EditLibraryTemplateForm from '../../Helpers/EditLibraryTemplateForm';


export default function RolfingLibrary() {
    const [templates, setTemplates] = useState([]);
    const [selectedTemplate, setSelectedTemplate] = useState(null);
    const [previewPage, setPreviewPage] = useState(1);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [showPreview, setShowPreview] = useState(false);
    const [showCloneModal, setShowCloneModal] = useState(false);
    const [showEditTitle, setShowEditTitle] = useState(false);

    const api = useApi();

    useEffect(() => {
        fetchTemplates();
    }, []);

    if (isLoading) {
        return <p><ActivityIndicator color={'black'} /></p>;
    }

    function fetchTemplates() {
        api.get("/library/rolfingtemplates")
            .then((data) => {
                setTemplates(data);

            }).catch((err) => {
                console.error("Error fetching templates:", err);
                setError("Failed to load templates. Please try again later.");
            }
            ).finally(() => {
                setIsLoading(false);
            });
    }

    function handleSelectTemplate(templateId, action) {
        api.get(`/library/rolfingtemplates/${templateId}`)
            .then((data) => {
                setSelectedTemplate(data);

                switch(action) {
                    case "preview":
                        setShowPreview(true);
                        break;
                    case "clone":
                        setShowCloneModal(true);
                        break;
                    default:
                        break;
                }

            }).catch((err) => {
                console.error("Error selecting template:", err);
                setError("Failed to load template. Please try again later.");
            });
    }

    function handleDeleteTemplate(templateId) {
        if (window.confirm("Are you sure you want to delete this template? This action cannot be undone.")) {
            api.delete(`/library/rolfingtemplates/${templateId}`).then(() => {
                setTemplates(templates.filter(template => template.ID !== templateId));
                setSuccess("Template deleted successfully.");
                if (selectedTemplate && selectedTemplate.ID === templateId) {
                    setSelectedTemplate(null);
                }
            }).catch((err) => {
                console.error("Error deleting template:", err);
                setError("Failed to delete template. Please try again later.");
            }).finally(() => {
                setTimeout(() => {
                    setSuccess("");
                    setError("");
                }, 5000);
            });
        }
    }

    function handleShowEditTitle(templateId) {
        setSelectedTemplate(templates.find(t => t.ID === templateId));

        if (showEditTitle === templateId) {
            setShowEditTitle(null);
        } else {
            setShowEditTitle(templateId);
        }
    }

    return (
        <div>
            <h4>Rolfing templates</h4>
            <p>Here you can view the Rolfing templates avaliable in the template library. Click on the name of a template to view it. Add a new template to the library by navigating to the template in question, click on "Clone template" and select "Clone to library".</p>

            {error && <p className="formControlError">{error}</p>}
            {success && <p className="formControlSuccess">{success}</p>}

            <table>
                <thead>
                    <tr>
                        <th>Template</th>
                        <th>Status</th>
                        <th>Edit</th>
                        <th>Clone</th>
                        <th>Delete</th>
                    </tr>
                </thead>
                <tbody>

                    {templates.filter((template) => !template.pulseTemplate).length > 0 ?
                        templates.filter((template) => !template.pulseTemplate).map((template, index) => (
                            <tr key={index}>
                                <td><span><a onClick={() => handleSelectTemplate(template.ID, "preview")} >{template.name}</a></span></td>
                                 <td>{template.active ? <span>Active</span> : <span className="inactive">Inactive</span>}</td>
                                 <td><a onClick={() => { handleShowEditTitle(template.ID); }} href="#">{!showEditTitle ? <i className="fa fa-pencil" aria-hidden="true" /> : <i className='fa fa-times' aria-hidden="true" />} Edit</a></td>
                                <td><a onClick={() => { handleSelectTemplate(template.ID, "clone"); }} href="#"><i className="fa fa-clone" aria-hidden="true" /> Clone</a></td>
                                <td><a style={{ color: "red" }} onClick={() => handleDeleteTemplate(template.ID)} href="#"><i className="fa fa-trash" aria-hidden="true" /> Delete</a></td>
                            </tr>
                        )) : <tr>
                            <td colSpan={5}>No templates found</td>
                        </tr>
                    }
                </tbody>
            </table>

            <p className="meta"><i className="fa fa-info-circle" aria-hidden="true" /> Click "edit" to change the title or status of a template. Further changes can be made by cloning the template into an organisation and editing it there.</p>

            <PreviewPaginator values={selectedTemplate} startPage={-1} showPreview={showPreview} setShowPreview={setShowPreview}>
                <RolfingTemplatePreviewPages />
            </PreviewPaginator>

            <Modal modalTitle={"Clone template"} isOpen={showCloneModal} onClose={() => setShowCloneModal(false)}>
                <CloneTemplateForm template={selectedTemplate} type="rolfing" onClose={() => setShowCloneModal(false)} disableCloneToLibrary={true} />
            </Modal>

            <Modal modalTitle={"Edit template title and status"} isOpen={showEditTitle} onClose={() => setShowEditTitle(false)}>
                <EditLibraryTemplateForm 
                    selectedTemplate={selectedTemplate} 
                    setSelectedTemplate={setSelectedTemplate} 
                    onError={(msg) => setError(msg)} 
                    onSuccess={(msg) => {
                        setSuccess(msg)
                        fetchTemplates(); //Refresh the list of temlates
                    }} 
                    onHide={() => setShowEditTitle(false)} 
                />
            </Modal>

        </div>
    )
}